(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1918],{

/***/ 81965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28086);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Medias = function Medias(props) {
  var _ref;

  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$desc = props.desc,
      desc = _props$desc === void 0 ? '' : _props$desc,
      _props$features = props.features,
      features = _props$features === void 0 ? [] : _props$features,
      _props$bgImage = props.bgImage,
      bgImage = _props$bgImage === void 0 ? '' : _props$bgImage,
      _props$bgImageM = props.bgImageM,
      bgImageM = _props$bgImageM === void 0 ? '' : _props$bgImageM,
      _props$imgPre = props.imgPre,
      imgPre = _props$imgPre === void 0 ? '' : _props$imgPre,
      type = props.type;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().media), type === 1 && (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().media1)),
    style: {
      backgroundImage: "url(".concat(size.width < 768 ? (_ref = "".concat(imgPre).concat(bgImageM)) !== null && _ref !== void 0 ? _ref : "".concat(imgPre).concat(bgImage) : "".concat(imgPre).concat(bgImage), ")")
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().desc),
        dangerouslySetInnerHTML: {
          __html: desc.replace(/\n/g, '<br/>')
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().features),
        children: features.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().feature),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: "".concat(imgPre, "feature-icon").concat(index, ".png"),
              alt: "media"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
              children: item.name
            })]
          }, item.name);
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Medias);

/***/ }),

/***/ 58262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/product/relevance/wrapper/index.module.scss
var index_module = __webpack_require__(89262);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/tdk/index.tsx + 1 modules
var tdk = __webpack_require__(6071);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/product/relevance/nav/index.module.scss
var nav_index_module = __webpack_require__(73649);
var nav_index_module_default = /*#__PURE__*/__webpack_require__.n(nav_index_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/product/relevance/nav/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */








var timer;

var Nav = function Nav(_ref) {
  var defaultIndex = _ref.defaultIndex,
      menu = _ref.menu,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 1 : _ref$type;

  var _useState = (0,react.useState)(defaultIndex || 0),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      once = _useState3[0],
      setOnce = _useState3[1]; //首次动画执行


  var count = (0,react.useRef)(0); // 首次动画执行占位不需要过渡效果 0初始状态 1 首次动画执行（自动滚动），其余为手动滚动

  var dom = (0,react.useRef)(null);
  var subNav = (0,react.useRef)();
  var menuRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var onScroll = (0,react.useCallback)(function () {
    var scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 100) {
      count.current++;
      setSticky(true);
      setOnce(false);
      count.current++;
    } else {
      if (count.current >= 1) {
        count.current = 2;
      }

      setSticky(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  (0,react.useEffect)(function () {
    if (window.innerWidth > 768) {
      setOnce(true);
      requestAnimation();
    }
  }, []);

  var requestAnimation = function requestAnimation() {
    var scrollTop = document.documentElement.scrollTop;
    var speed = scrollTop > 80 ? 1 : 2;
    timer = window.requestAnimationFrame(function () {
      if (scrollTop > 100) {
        cancelAnimationFrame(timer);
      } else {
        document.documentElement.scrollTop = scrollTop + speed;
        requestAnimation();
      }
    });
  }; // 移动端-设置当前页面导航按钮是否在可视口完全显示


  (0,react.useEffect)(function () {
    var _menuRef$current;

    var childNodes = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.childNodes;

    if (childNodes && window.innerWidth < 768) {
      var child = childNodes[current];
      var position = child.getClientRects();
      var _position$ = position[0],
          left = _position$.left,
          width = _position$.width;
      var diff = left + width - window.innerWidth;

      if (diff > 0) {
        if (menuRef.current) {
          var distance = menuRef.current.scrollLeft + diff + 10;
          menuRef.current.scrollLeft = distance;
        }
      }
    }
  }, []);

  var Goto = function Goto(index, url) {
    setCurrent(index);
    router.push(url); // window.location.href = url;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: dom,
      className: classnames_default()((nav_index_module_default()).nav__theme_parent, once && (nav_index_module_default()).once, sticky && (nav_index_module_default()).sticky),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default()).logo, sticky && (nav_index_module_default()).show, !sticky && (nav_index_module_default()).hide),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: constants/* homeUrl */.hB,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/v2/images/login-logo.png",
            alt: "logo",
            width: "134",
            height: "27"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default())["nav-pc"]),
        ref: subNav,
        children: menu.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return Goto(index, item.link);
            },
            className: classnames_default()((nav_index_module_default())["nav-pc-item"], index === current && (nav_index_module_default()).focus),
            children: item.name
          }, item.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((nav_index_module_default()).transition, count.current === 1 && (nav_index_module_default()).once, count.current > 1 && sticky && (nav_index_module_default()).active, 'for-pc')
    }), type === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob"],
      ref: menuRef,
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    }), type === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob-2"],
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    })]
  });
};

/* harmony default export */ var nav = (Nav);
;// CONCATENATED MODULE: ./src/components/product/relevance/wrapper/index.tsx









var menu1 = [{
  name: '智能硬件',
  link: '/hardware'
}, {
  name: '软件客户端',
  link: '/client'
}];
var menu2 = [{
  name: '一体化4K终端',
  link: '/hardware/fullSceneTerminal'
}, {
  name: '小鱼云镜',
  link: '/hardware/cloudMirrorSystem'
}, {
  name: '大型终端',
  link: '/hardware/flagshipTerminal'
}, {
  name: '中型终端',
  link: '/hardware/mediumTerminal'
}, {
  name: '中小型终端',
  link: '/hardware/integratedTerminal'
}, {
  name: '智能会议平板',
  link: '/hardware/meetingBoard'
}, {
  name: '电视墙服务器',
  link: '/hardware/TVwall'
}];
var menus = {
  '1': {
    name: '云视频会议',
    menu: menu1
  },
  '2': {
    name: '智能硬件',
    menu: menu2,
    type: 2
  }
};

var Wrapper = function Wrapper(_ref) {
  var title = _ref.title,
      current = _ref.current,
      children = _ref.children,
      _ref$menuIndex = _ref.menuIndex,
      menuIndex = _ref$menuIndex === void 0 ? '1' : _ref$menuIndex,
      customClass = _ref.customClass,
      pageKey = _ref.pageKey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    layoutClass: (index_module_default()).layout,
    headerClass: (index_module_default()).header,
    children: [pageKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(tdk/* default */.Z, {
      pageKey: pageKey
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: [menus[menuIndex].name, "-", title]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()((index_module_default()).main, customClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(nav, {
        menu: menus[menuIndex].menu,
        defaultIndex: current,
        type: menus[menuIndex].type || 1
      }), children]
    })]
  });
};

/* harmony default export */ var wrapper = (Wrapper);

/***/ }),

/***/ 34790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1730);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var components_transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66335);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var Index = function Index(props) {
  var _props$title, _ref, _props$data, _props$data2;

  var _props$animate = props.animate,
      animate = _props$animate === void 0 ? 'none' : _props$animate,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      _props$bgImg = props.bgImg,
      bgImg = _props$bgImg === void 0 ? '' : _props$bgImg,
      _props$mBgImg = props.mBgImg,
      mBgImg = _props$mBgImg === void 0 ? '' : _props$mBgImg;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scheme), props.isBg && (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bg), props.className),
    style: {
      backgroundImage: "url(".concat(size.width < 768 ? mBgImg !== null && mBgImg !== void 0 ? mBgImg : bgImg : bgImg, ")")
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      delay: delay,
      offset: offset,
      animate: animate,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: 'title',
        dangerouslySetInnerHTML: {
          __html: ((_props$title = props.title) === null || _props$title === void 0 ? void 0 : _props$title.replace(/\n/g, '<br>')) || '解决方案'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      delay: delay,
      offset: offset,
      animate: animate,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: 'mobTitle',
        dangerouslySetInnerHTML: {
          __html: (_ref = props.mTitle ? props.mTitle : props.title || '') === null || _ref === void 0 ? void 0 : _ref.replace(/\n/g, '<br>')
        }
      })
    }), props.noTitle && size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: 'scheme-wrap',
      children: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.map(function (item) {
        var _item$title;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "scheme-item",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.3,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              style: {
                backgroundImage: "url(".concat(item.mUrl, ")")
              },
              className: "img-wrapper-m"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.6,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "scheme-item-title",
              dangerouslySetInnerHTML: {
                __html: (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.replace(/\n/g, '<br>')
              }
            })
          })]
        }, item.title);
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "content grid-".concat(props.type),
      children: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.map(function (item) {
        var _item$mUrl, _item$title2, _ref2, _item$desc;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "scheme-item",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.3,
            offset: offset,
            animate: animate,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: item.pcUrl,
              className: "img-wrapper",
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: (_item$mUrl = item.mUrl) !== null && _item$mUrl !== void 0 ? _item$mUrl : item.pcUrl,
              className: "img-wrapper-m",
              alt: ""
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.6,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "scheme-item-content",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('scheme-item-title', 'for-pc'),
                dangerouslySetInnerHTML: {
                  __html: (_item$title2 = item.title) === null || _item$title2 === void 0 ? void 0 : _item$title2.replace(/\n/g, '<br>')
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('scheme-item-title', !item.desc && 'scheme-item-title-normal', 'for-mobile'),
                dangerouslySetInnerHTML: {
                  __html: (_ref2 = item.mTitle ? item.mTitle : item.title || '') === null || _ref2 === void 0 ? void 0 : _ref2.replace(/\n/g, '<br>')
                }
              }), item.desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: "scheme-item-desc",
                dangerouslySetInnerHTML: {
                  __html: (_item$desc = item.desc) === null || _item$desc === void 0 ? void 0 : _item$desc.replace(/\n/g, '<br>')
                }
              })]
            })
          })]
        }, item.title);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Index);

/***/ }),

/***/ 55921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_product_scheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34790);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53784);
/* harmony import */ var components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58262);
/* harmony import */ var components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12221);
/* harmony import */ var components_medias__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81965);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8165);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
/*
 * 一体化4K终端
 */










var IMG_PATH = 'https://sdk-source.xylink.com/website/assets/hardware/cloud/AE350_380/';
var scheme = [{
  title: '领导桌面视频会商',
  pcUrl: IMG_PATH + 'scheme-img3.jpg'
}, {
  title: '客服专家坐席',
  pcUrl: IMG_PATH + 'scheme-img2.jpg'
}, {
  title: '灵活场景视频协作',
  pcUrl: IMG_PATH + 'scheme-img1.jpg'
}, {
  title: '应急指挥调度舱',
  pcUrl: IMG_PATH + 'scheme-img0.jpg'
}];
var features = [{
  name: '声音'
}, {
  name: '视频'
}, {
  name: '控制'
}, {
  name: 'Wi_Fi'
}, {
  name: 'SIM卡'
}, {
  name: '电池'
}];

var Index = function Index() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    title: "\u4E00\u4F53\u53164K\u7EC8\u7AEF",
    menuIndex: "2",
    current: 0,
    customClass: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ae350),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      mUrl: "".concat(IMG_PATH, "m/bgM-image1.png"),
      className: ((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner), (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().firstBanner)),
      type: 4,
      pcUrl: "".concat(IMG_PATH, "bg-image0.jpg"),
      title: '一体化4K\n全场景终端',
      animate: 'fadeIn',
      delay: 0.5,
      desc: '可移动便携式视频会议终端，远程办公头等舱\n支持各种网络会议室、移动桌面、户外等全场景应用',
      mDesc: '可移动便携式视频会议终端，远程办公头等舱\n支持各种网络会议室、移动桌面、户外等全场\n景应用'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().outline),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
        children: "\u684C\u9762\u81FB\u54C1"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().outlineWrap),
        children: new Array(4).fill('').map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("img", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().outlineItem),
            src: "".concat(IMG_PATH, "desk-icon").concat(index, ".jpg"),
            alt: ""
          }, index);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      mUrl: "".concat(IMG_PATH, "m/bgM-image3.jpg"),
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)),
      type: 4,
      pcUrl: "".concat(IMG_PATH, "bg-image3.jpg"),
      title: '灵动操控，极简体验',
      animate: 'fadeIn',
      delay: 0.5,
      desc: '高度集成的一体化触控终端，机身小巧灵便\n弹指间掌控更多功能，妙趣无限'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_medias__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      title: "\u96C6\u5927\u6210\u8005\uFF0C\u81F3\u7B80\u201C\u65E0\u7EBF\u201D",
      desc: "\u8F7B\u677E\u90E8\u7F72\uFF0C\u96C6\u97F3\u89C6\u9891\u80FD\u529B\u4E8E\u4E00\u4F53\uFF0C\u652F\u6301WiFi\u3001\u79FB\u52A8\u8702\u7A9D\u7F51\u7EDC\u7B49\u63A5\u5165\u65B9\u5F0F",
      features: features,
      imgPre: IMG_PATH,
      bgImage: 'bg-image4.jpg',
      bgImageM: 'm/bg-img0.jpg'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      mUrl: "".concat(IMG_PATH, "m/bgM-image2.jpg"),
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner), (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner1)),
      type: 4,
      pcUrl: "".concat(IMG_PATH, "bg-image2.jpg"),
      title: '性能拓展，应用无限',
      animate: 'fadeIn',
      delay: 0.5,
      desc: '可拓展4K云台摄像机，全向数字麦克风\n外接电视大屏扩展显示，带来优异会议体验'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      mUrl: "".concat(IMG_PATH, "m/bgM-image4.jpg"),
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)),
      type: 3,
      pcUrl: "".concat(IMG_PATH, "bg-image1.jpg"),
      title: '全网环境适应，稳定保障',
      animate: 'fadeIn',
      delay: 0.5,
      desc: 'H.264、H.265柔性编解码算法\n超强网络适应性，有效保障会议稳定流畅'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_product_scheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      animate: "fadeIn",
      delay: 0.5,
      type: 3,
      data: scheme,
      title: '应用场景',
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().scene)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().contact),
      btnType: 'newBtn'
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Index);

/***/ }),

/***/ 92914:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/fullSceneTerminal",
      function () {
        return __webpack_require__(55921);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"medias_border__px__BOhua","border__px-before":"medias_border__px-before__RZloI","border__px-before1":"medias_border__px-before1__DQY85","border-children1":"medias_border-children1__rTtSZ","border-children2":"medias_border-children2__TcDDQ","for-mobile":"medias_for-mobile__iwzwX","for-pc":"medias_for-pc__C9i_e","media":"medias_media__Idg9d","content":"medias_content__aDFN9","title":"medias_title__DMzzX","desc":"medias_desc__z9mzi","features":"medias_features__6_YAa","feature":"medias_feature__h6aQ9","name":"medias_name__HICDw","media1":"medias_media1__8MYTE"};

/***/ }),

/***/ 73649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"nav_border__px__LnplE","border__px-before":"nav_border__px-before__EVov9","border__px-before1":"nav_border__px-before1__2oD1e","border-children1":"nav_border-children1__g0F3X","border-children2":"nav_border-children2__DnnSf","for-mobile":"nav_for-mobile__ZciXU","for-pc":"nav_for-pc__z_KI0","nav__theme_parent":"nav_nav__theme_parent__T4U4O","logo":"nav_logo__WR8zR","show":"nav_show__4YtHP","nav-pc":"nav_nav-pc__bFsJ0","nav-pc-item":"nav_nav-pc-item__kYYYW","focus":"nav_focus__ByYUr","once":"nav_once__aksOZ","sticky":"nav_sticky__l7SSZ","transition":"nav_transition__B1wHH","active":"nav_active__1D68f","nav-mob":"nav_nav-mob__FuCYJ","nav-mob-2":"nav_nav-mob-2__6Mv2f","nav-mob-item":"nav_nav-mob-item__6k_Rb"};

/***/ }),

/***/ 89262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"wrapper_border__px__F6VvU","border__px-before":"wrapper_border__px-before__Mxpn1","border__px-before1":"wrapper_border__px-before1__EFvO6","border-children1":"wrapper_border-children1__KmKjR","border-children2":"wrapper_border-children2__7Jboy","for-mobile":"wrapper_for-mobile__2kveH","for-pc":"wrapper_for-pc__yuzrw","layout":"wrapper_layout__j4SAy","header":"wrapper_header__l9dYm"};

/***/ }),

/***/ 1730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"scheme_border__px__p2mre","border__px-before":"scheme_border__px-before__Z5zYd","border__px-before1":"scheme_border__px-before1__85u3k","border-children1":"scheme_border-children1__3YAlL","border-children2":"scheme_border-children2__7mE0p","for-mobile":"scheme_for-mobile___ycZS","for-pc":"scheme_for-pc__UIzZn","scheme":"scheme_scheme__rxdlU","bg":"scheme_bg__bVFmx"};

/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"fullSceneTerminal_border__px__QB30s","border__px-before":"fullSceneTerminal_border__px-before__owBMY","border__px-before1":"fullSceneTerminal_border__px-before1__mQtX5","border-children1":"fullSceneTerminal_border-children1__fpJTK","border-children2":"fullSceneTerminal_border-children2__OjM_T","for-mobile":"fullSceneTerminal_for-mobile__mUavQ","for-pc":"fullSceneTerminal_for-pc__S99Gw","hardware":"fullSceneTerminal_hardware__wxAtp","contentWrapper":"fullSceneTerminal_contentWrapper__zAvkO","header":"fullSceneTerminal_header__0DvV5","bigTitle":"fullSceneTerminal_bigTitle__WyqpN","arrowImg":"fullSceneTerminal_arrowImg__Mw3h9","horizontal":"fullSceneTerminal_horizontal__Ur6yj","totalBanner":"fullSceneTerminal_totalBanner__XNQ7q","banner":"fullSceneTerminal_banner__YM_N2","title":"fullSceneTerminal_title__tp0jx","desc":"fullSceneTerminal_desc__u9x7p","knowMore":"fullSceneTerminal_knowMore__P0PVS","contact":"fullSceneTerminal_contact__L6NxM","ae350":"fullSceneTerminal_ae350__06P_G","firstBanner":"fullSceneTerminal_firstBanner__HqPqX","banner1":"fullSceneTerminal_banner1__C6rmB","outline":"fullSceneTerminal_outline__iwY6Y","outlineWrap":"fullSceneTerminal_outlineWrap__djzKz","outlineItem":"fullSceneTerminal_outlineItem__8O_dG","scene":"fullSceneTerminal_scene__7yY8r"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9243,9092,9774,2888,179], function() { return __webpack_exec__(92914); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);